import {NgModule} from '@angular/core';
import {AdminRoutingModule} from './admin-routing.module';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {EventSearchService} from './event-search.service';
import {UserSearchService} from './user-search.service';
import {CompanySearchService} from './company-search.service';
import {SharedModule} from '../shared/shared.module';
import {CompanyApiService} from '../shared/company-api.service';
import {EventsApiService} from './events.service';
import {LoginComponent} from './login/login.component';
import {FormsModule} from '@angular/forms';
import {DatetimeTestComponent} from './datetime-test/datetime-test.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,

    // this needs to be declared after all modules
    AdminRoutingModule,
  ],
  exports: [],
  providers: [EventSearchService, EventsApiService, UserSearchService, CompanySearchService, CompanyApiService],
  declarations: [LoginComponent, DatetimeTestComponent],
})
export class AdminModule {}
